<p-toast position="bottom-right"></p-toast>
<app-cc-table-edit body #ccTable [transPartKey]="transPartKey"
                   [tableConfig]="tableConfig" [headerButtonConfig]="headerButtonConfig"
                   [records]="records" [totalRecords]="totalRecords" [loading]="tableLoading"
                   (onRowDblClick)="onRowDblClick($event)"
                   [fieldName]="'id'" [fieldId]="'id'"
                   [(selectedRecord)]="formRecord"
                   [(selectedRecords)]="selectedRecords" (selectedRecordsChange)="onselectionchanged($event)"
                   [defaultSortField]="'creationDate'" [defaultSortOrder]="1"
                   [selectionMode]="'multiple'"     (recordChange)="recordChange($event)"
>
  <!--  (selectedRecordChange)="selectedRecords.emit($event)"-->
  <span toolbar-left class="table-toolbar-title ">
  <button pButton
          type="button" [disabled]="tableLoading"
          (click)="showBatchUpdate()" [icon]="'fas fa-pen-to-square'"
          [class]="'p-button-text p-button-sm'" [pTooltip]="'page.'+transPartKey+'.batch-update-tooltip'|translate"
          [label]=""
  ></button>
      <i class="toolbar-separator fa fa-diamond"></i>
  </span>
  <span toolbar-left class="d-flex" *ngIf="formConfig">
    <app-cc-form [formConfig]="formConfig" [(formRecord)]="tableCurrentRequest" [transPartKey]="transPartKey"
                 [loadingProgressValue]="settingsFormLoadingProgressValue" [loading]="tableLoading"></app-cc-form>
  </span>
  <span toolbar-left class="ml-20-imp">
    <button pButton type="button" (click)="refreshTable()"
            [label]="'common.search' | translate"
            icon="fa fa-magnifying-glass"
            class="p-button-warning p-button-sm"></button>
  </span>
  <!--  [currentRequest]="tableCurrentRequest"  (loadRecordsEvent)="needLoadRecords($event)"-->


  <!--  <span toolbar-left style="margin-left: 20px !important;">-->
  <!--      <i class="toolbar-separator fa fa-diamond"></i>-->
  <!--  </span>-->
  <!--  <span toolbar-left style="margin-left: 20px !important;">-->
  <!--        <button type="button" class="btn btn-primary" (click)="">-->
  <!--          <i class="fa fa-edit fa-lg"></i> Edit Rate-->
  <!--      </button>-->
  <!--  </span>-->
</app-cc-table-edit>

<app-batch-update-order-amendment-form [(dialogFormVisible)]="batchUpdateDialogVisible"
                                       [selectedRecords]="selectedRecords"
                                       [formRecord]="batchFormRecord"
                                       [transPartKey]="transPartKey"
                                       (onSavedForm)="applyBatchToRecordsTable($event)"
></app-batch-update-order-amendment-form>
